<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight] [crumbs]="['Settings', 'Checkout Settings']"  current="Reduce Plan Price"></fury-breadcrumbs>
    </fury-page-layout-header>
    <div fxLayout="column" fxLayoutAlign="start center">
      <div [@fadeInUp] class="card">
  
            <form [formGroup]="reducePlanPriceForm" style="width: 100%;">
              <div class="content" fxLayout="column" fxLayoutGap="8px">
                  <div  formGroupName="grossAmount">
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                      <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label>Monthly Add Display Price</mat-label>
                        <input matInput placeholder="Monthly Add Display Price" formControlName="displayMonthlyGrossPrice" mask="separator.2" thousandSeparator="," [prefix]="reducePlanPriceForm.get('grossAmount.displayMonthlyGrossPrice').value ? '$' : ''"/>
                        <mat-error *ngIf="reducePlanPriceForm.get('grossAmount.displayMonthlyGrossPrice').hasError('required') && reducePlanPriceForm.get('grossAmount.displayMonthlyGrossPrice'
                        )!.touched
                      ">
                      This field is required.
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline" fxFlex="auto">
                        <mat-label>Yearly Add Display Price</mat-label>
                        <input matInput placeholder="Yearly Add Display Price" formControlName="displayYearlyGrossPrice" mask="separator.2" thousandSeparator="," [prefix]="reducePlanPriceForm.get('grossAmount.displayYearlyGrossPrice').value ? '$' : ''"/>
                        <mat-error *ngIf="reducePlanPriceForm.get('grossAmount.displayYearlyGrossPrice').hasError('required') && reducePlanPriceForm.get('grossAmount.displayYearlyGrossPrice'
                        )!.touched
                      ">
                      This field is required.
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label>Two Years Add Display Price</mat-label>
                          <input matInput placeholder="Two Years Add Display Price" formControlName="displayTwoYearlyGrossPrice" mask="separator.2" thousandSeparator="," [prefix]="reducePlanPriceForm.get('grossAmount.displayTwoYearlyGrossPrice').value ? '$' : ''"/>
                          <mat-error *ngIf="reducePlanPriceForm.get('grossAmount.displayTwoYearlyGrossPrice').hasError('required') && reducePlanPriceForm.get('grossAmount.displayTwoYearlyGrossPrice'
                          )!.touched
                        ">
                        This field is required.
                          </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label>Three Years Add Display Price</mat-label>
                          <input matInput placeholder="Three Years Add Display Price" formControlName="displayThreeYearlyGrossPrice" mask="separator.2" thousandSeparator="," [prefix]="reducePlanPriceForm.get('grossAmount.displayThreeYearlyGrossPrice').value ? '$' : ''"/>
                          <mat-error *ngIf="reducePlanPriceForm.get('grossAmount.displayThreeYearlyGrossPrice').hasError('required') && reducePlanPriceForm.get('grossAmount.displayThreeYearlyGrossPrice'
                          )!.touched
                        ">
                        This field is required.
                          </mat-error>
                        </mat-form-field>
                    </div>
                    <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="10px">
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label>Four Years Add Display Price</mat-label>
                          <input matInput placeholder="Four Years Add Display Price" formControlName="displayFourYearlyGrossPrice" mask="separator.2" thousandSeparator="," [prefix]="reducePlanPriceForm.get('grossAmount.displayFourYearlyGrossPrice').value ? '$' : ''"/>
                          <mat-error *ngIf="reducePlanPriceForm.get('grossAmount.displayFourYearlyGrossPrice').hasError('required') && reducePlanPriceForm.get('grossAmount.displayFourYearlyGrossPrice'
                          )!.touched
                        ">
                        This field is required.
                          </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline" fxFlex="auto">
                          <mat-label>Five Years Add Display Price</mat-label>
                          <input matInput placeholder="Five Years Add Display Price" formControlName="displayFiveYearlyGrossPrice" mask="separator.2" thousandSeparator="," [prefix]="reducePlanPriceForm.get('grossAmount.displayFiveYearlyGrossPrice').value ? '$' : ''"/>
                          <mat-error *ngIf="reducePlanPriceForm.get('grossAmount.displayFiveYearlyGrossPrice').hasError('required') && reducePlanPriceForm.get('grossAmount.displayFiveYearlyGrossPrice'
                          )!.touched
                        ">
                        This field is required.
                          </mat-error>
                        </mat-form-field>
                    </div>
                  </div>
              </div>
              <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            
                <button mat-button type="button" class="sub-button" (click)="update()"><span>Update</span></button>
                <button mat-button type="button" class="can-button" (click)="location.back()"><span>Back</span></button>
              </div>
            </form>
      </div>
    </div>
  </fury-page-layout>